<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M13.462 18.046l7.458-7.463 1.414 1.414-8.834 8.84-.037-.038-.038.038-4.84-4.84L10 14.584l3.462 3.463z"/>
</svg>
